import React, { useCallback, useEffect, useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  FlatList,
  Platform
} from 'react-native';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';
import TopGreenHeader from '../Common/TopGreenHeader';
import CheckIcon from '../.././assets/tickmark.png';
import { getAllAddressCreator, getAllKidsCreator, loginActions, resetCreateKidSuccessCreator } from '../../slices/authSlice';
import { Bounce, ToastContainer, toast } from 'react-toastify';
import AsyncStorage from '@react-native-async-storage/async-storage';
import API_PATHS from '../../apiCalls/ApiPath';
import axios from 'axios';


// This map will be used to assign kid limit based on the service selected if not present its 1 by default
const KID_LIMITS_BY_SERVICE = {
  TRANSPORT: 3
}

const SelectKidScreen = ({ route }) => {
  console.log("hello from select kid screen")
  const dispatch = useDispatch();

  const navigation = useNavigation();
  const serviceScheduled = useSelector(state => state.auth.serviceScheduled);
  const getAllkids = useSelector(state => state.auth.getAllkids);
  const [selectedKidsId, setSelectedKidsId] = useState([]);
  const [kidsSelected, setKidsSelected] = useState([]);
  const [allKidsData, setAllKidsData] = useState([]);
  const planChoosed = useSelector(state => state.auth.planChoosed);
  const { serviceName } = serviceScheduled

  const numOfKids = planChoosed?.numOfKids
    ? planChoosed.numOfKids
    : (KID_LIMITS_BY_SERVICE[serviceName] ?? 1)
  // Event bookings let the parent pick any number of kids (no fixed plan count).
  const isEventService = typeof serviceName === 'string' && serviceName.startsWith('EVENT-');

  const fetchAllKids = async () => {
    try {
      const token = await AsyncStorage.getItem('token');
      const clientToken = await AsyncStorage.getItem('clientToken');
      console.log(token);

      const response = await axios.get(`${API_PATHS.BASE_URL}${API_PATHS.GET_ALL_KIDS_API}`, {
        headers: {
          Authorization: `Bearer ${clientToken || token}`,
        },
      });

      console.log("This is kid data", response.data.Data.kids);
      setAllKidsData(response.data.Data.kids);

    } catch (error) {
      toast.error("Unable to fetch kids. Please try again later!");
    }
  }

  useFocusEffect(
    useCallback(() => {
      console.log("running dispatch");
      fetchAllKids();
      // dispatch(getAllKidsCreator());
    }, [])
  );

  // useEffect(() => {
  //   console.log("running useEffect");
  //   setAllKidsData(getAllkids?.Data?.kids || []);
  // }, [getAllkids]);

  const toggleKidSelection = (item, id) => {
    if (selectedKidsId.includes(id)) {
      setSelectedKidsId(selectedKidsId.filter(kidId => kidId !== id));
      setKidsSelected(kidsSelected.filter(kid => kid.id !== id));
    } else if (!isEventService && selectedKidsId.length >= numOfKids) {
      toast.warn(`Please select ${numOfKids} kid(s), as per plan you selected`);
    } else {
      setSelectedKidsId([...selectedKidsId, id]);
      setKidsSelected([...kidsSelected, item]);
    }
  };

  const handleNext = () => {

    dispatch(loginActions.setTotalSelectedKids(kidsSelected));
    dispatch(getAllAddressCreator());
    if (isEventService && selectedKidsId.length < 1) {
      toast.error('Please select at least one kid');
    } else if (!isEventService && (selectedKidsId.length > numOfKids || selectedKidsId.length < 1)) {
      if (selectedKidsId.length < 1) {
        toast.error("Please select at least one kid");
      } else {
        toast.error(`Please select maximum ${numOfKids} kid(s), as per plan you selected`);
      }
    } else {
      if (serviceName === 'TRANSPORT') {
        navigation.navigate('SelectTransport');
      } else if (serviceName === 'HOMECARE') {
        navigation.navigate('SelectAddressScreen');
      } else if (serviceName === null) {
        navigation.navigate('ProfileScreen');
      } else {
        navigation.navigate('ConfirmBooking');
      }
    }
  };

  const renderKidItem = ({ item }) => {
    const isSelected = selectedKidsId.includes(item.id);
    return (
      <TouchableOpacity style={styles.kidItem} onPress={() => toggleKidSelection(item, item.id)}>
        <Image
          source={item.profilePic ? { uri: item.profilePic } : require('../../assets/AddKidPic.png')}
          style={styles.kidImage}
        />
        <View style={styles.kidInfo}>
          <Text style={styles.kidName}>{item.name}</Text>
          <Text style={styles.kidDetails}>{`${item.age} years, ${item.gender === 'BOY' ? 'Boy' : 'Girl'}`}</Text>
        </View>
        {isSelected && <Image source={CheckIcon} style={styles.checkIcon} />}
      </TouchableOpacity>
    );
  };

  return (
    <>
      <TopGreenHeader Heading={'Select Kid(s)'} navigation={navigation} isBackIcon={true} isNotification={false} />
      <View style={styles.container}>
        <ToastContainer />
        <FlatList
          data={allKidsData}
          renderItem={renderKidItem}
          keyExtractor={item => item.id.toString()}
          contentContainerStyle={styles.listContainer}
        />

        <View style={styles.buttonContainer}>
          <TouchableOpacity style={styles.addButton} onPress={() => {
            dispatch(resetCreateKidSuccessCreator());
            navigation.navigate('AddNewKidScreen');
          }}>
            <Text style={styles.addButtonText}>Add New Kid</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.addButton} onPress={handleNext}>
            <Text style={styles.addButtonText}>Next</Text>
          </TouchableOpacity>
        </View>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    padding: 16,
  },
  listContainer: {
    paddingBottom: 16,
  },
  kidItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    marginBottom: 8,
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
    justifyContent: 'space-between',
  },
  kidImage: {
    width: 50,
    height: 50,
    borderRadius: 25,
    marginRight: 12,
  },
  kidInfo: {
    flex: 1,
  },
  kidName: {
    fontSize: 18,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "normal",
    fontWeight: "bold",
  },
  kidDetails: {
    fontSize: 14,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "normal",
    color: '#666',
  },
  checkIcon: {
    width: 20,
    height: 20,
    margin: 2
  },
  buttonContainer: {
    alignItems: 'center',
    marginTop: 16,
  },
  addButton: {
    backgroundColor: '#A3D900',
    paddingVertical: 16,
    paddingHorizontal: 24,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    width: '60%',
    marginBottom: 12,
  },
  addButtonText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#fff',
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "normal",
  },
});

export default SelectKidScreen;